export const scrollToY = (elem, scrollTargetY = 0, speed = 1000, easing = 'swing') => {
  // scrollTargetY: the target scrollY property of the elem
  // speed: time in pixels per second
  // easing: easing equation to use

  let currentTime = 0;
  const scrollTop = elem.scrollTop;
  const time = Math.max(0.1, Math.min(Math.abs(scrollTop - scrollTargetY) / speed, 0.8));
  const easingEquations = {
    linear: p => p,
    swing: p => 0.5 - Math.cos(p * Math.PI) / 2
  };

  function tick() {
    currentTime += 1 / 60;
    let p = currentTime / time;
    let t = easingEquations[easing](p);
    if (p < 1) {
      window.requestAnimationFrame(tick);
      elem.scrollTop = scrollTop + (scrollTargetY - scrollTop) * t;
    } else {
      elem.scrollTop = scrollTargetY;
    }
  }
  tick();
};
